/*global jQuery */
import SettingsMixin from 'utils/vue/mixins/settings'
import LangMixin from 'utils/vue/mixins/lang'

const mixins = [
  SettingsMixin,
  LangMixin,
]

export const props = {
  settings: {},
  translations: {},
  skipCustomMount: {}
}

export default {
  props,
  mixins,
  data() {
    return {
      MOUNT_TARGET: null,
      MOUNT_CONTAINER: null,
      MOUNT_CONTAINER_CLASSES: null,
      MOUNT_CONTAINER_CLEAR: false,
      hasMountPoint: false
    }
  },
  destroyed() {
    if (this && this.hasMountPoint) {
      if (this && this.$el) {
        this.$el.remove()
      }
    }
  },
  async mounted() {
    await this.$nextTick()
    if (this.MOUNT_TARGET && !this.skipCustomMount) {
      const target = jQuery(this.MOUNT_TARGET)
      const appendToContainerSelector = this.MOUNT_CONTAINER
      const appendToContainerClasses = this.MOUNT_CONTAINER_CLASSES
      let parent = target.children(appendToContainerSelector).last()
      if (!parent.length) {
        parent = jQuery(`<div class="${appendToContainerClasses}"></div>`).appendTo(target)
      }
      if (this.MOUNT_CONTAINER_CLEAR) {
        parent.empty()
      }
      parent.append(this.$el)
      this.hasMountPoint = true
    }
  }
}
